import React from 'react';
import '../styles/RelativeLocatorsExample.css';

const RelativeLocatorsExample = () => {
  return (
    <div className="relative-locators-page" id="relative-locators-page">
      <h2 className="relative-locators-heading">Selenium Relative Locators</h2>

      <div className="relative-locators-frame" id="relative-locators-frame">
        <div className="relative-locator-group relative-locator-group--vertical" id="above-section">
          <label htmlFor="above-target" className="relative-locator-field-label">
            Username
          </label>
          <input
            type="text"
            id="above-target"
            name="above_target"
            className="relative-locator-input"
            placeholder="Element above anchor"
          />
          <button type="button" id="login-button" className="relative-locator-anchor">
            Anchor: Login
          </button>
        </div>

        <div className="relative-locator-group relative-locator-group--vertical" id="below-section">
          <button type="button" id="search-button" className="relative-locator-anchor">
            Anchor: Search
          </button>
          <label htmlFor="below-target" className="relative-locator-field-label">
            Search term
          </label>
          <input
            type="text"
            id="below-target"
            name="below_target"
            className="relative-locator-input"
            placeholder="Element below anchor"
          />
        </div>

        <div className="relative-locator-group relative-locator-group--horizontal" id="left-section">
          <input
            type="text"
            id="left-target"
            name="left_target"
            className="relative-locator-input"
            placeholder="Element to the left"
          />
          <button type="button" id="submit-button" className="relative-locator-anchor">
            Anchor: Submit
          </button>
        </div>

        <div className="relative-locator-group relative-locator-group--horizontal" id="right-section">
          <button type="button" id="filter-button" className="relative-locator-anchor">
            Anchor: Filter
          </button>
          <input
            type="text"
            id="right-target"
            name="right_target"
            className="relative-locator-input"
            placeholder="Element to the right"
          />
        </div>
      </div>
    </div>
  );
};

export default RelativeLocatorsExample;
